export const GTM_ID = 'GTM-NL8PTF4';

export const DEV_URLS = [
  'localhost',
  'localhost:3001',
  '127.0.0.1',
  '127.0.0.1:3001',
];

export const PROD_DOMAIN = 'https://shopping-api.np.shopping';
export const DEV_DOMAIN = 'https://shoppingapi-novaplace.dev.npu.np.work';
